import { Button } from "components/DesignSystem/Button/Button";
import Modal from "components/DesignSystem/Modal/Modal";
import { StatusModal } from "components/DesignSystem/StatusModal/StatusModal";
import { BULK_INVOICE_ACTION, BULK_INVOICE_TYPE } from "constants/invoicing";
import { useToast } from "hooks/useToast";
import { useBulkUpdateInvoiceMutation } from "store/apis/invoices";
import { BackendError } from "types/utils/error";
import { pluralize } from "utils/pluralize";

export default function BillUnlinkTransactionsModal({
  groupId,
  entityId,
  selectedRows,
  success,
}: {
  groupId: string;
  entityId: string;
  selectedRows: string[];
  success: () => void;
}) {
  const [bulkUpdateOrDeleteInvoice, { isLoading: isUnlinkingTransactions }] =
    useBulkUpdateInvoiceMutation();
  const { alertToast, successToast } = useToast();

  const handleUnlinkTransactions = async () => {
    try {
      await bulkUpdateOrDeleteInvoice({
        groupId,
        entityId,
        record_ids: selectedRows,
        action: BULK_INVOICE_ACTION.UNLINK_TRANSACTIONS,
        type: BULK_INVOICE_TYPE.BILL,
      }).unwrap();
      success();
      successToast({ message: "Transactions unlinked successfully" });
    } catch (error) {
      alertToast({
        message:
          (error as BackendError).data?.error?.message ??
          "Failed to unlink transactions",
      });
    }
  };

  return (
    <>
      <StatusModal type="warning" title="Unlink transactions?">
        Are you sure you want to unlink all transactions linked to the{" "}
        <b>
          {pluralize(selectedRows.length, "selected bill", "selected bills")}
        </b>
        ? This may change the bill status and will update the corresponding
        transactions&apos; categorisation.
      </StatusModal>
      <Modal.FooterButtonGroup>
        <Modal.RawClose asChild>
          <Button size="small">Cancel</Button>
        </Modal.RawClose>
        <Button
          customType="primary"
          size="small"
          onClick={handleUnlinkTransactions}
          isLoading={isUnlinkingTransactions}
          disabled={isUnlinkingTransactions}
        >
          Confirm
        </Button>
      </Modal.FooterButtonGroup>
    </>
  );
}
